<template>
  <vs-row w-full>
    <vs-col :lg="5" :sm="12">
      <h1>Top Up</h1>
      <div class="chart-container mt-4">
        <div class="invoice-card">
          <vs-row>
            <vs-col :lg="12"> Current Balance </vs-col>
            <vs-col :lg="12"
              ><div class="flex">
                <div class="amount">
                  ${{
                    userInfo.clientData && userInfo.clientData.balanceAmount
                  }}
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <div class="topup_text">
          <img src="@/assets/icons/Icon (1).svg" alt="" /><span class="text"
            >Subscriber Id : &nbsp;&nbsp;&nbsp;{{
              userInfo.clientData && userInfo.clientData.accountNo
            }}
          </span>
        </div>
        <div class="topup_text">
          <img src="@/assets/icons/Icon (2).svg" alt="" /><span class="text"
            >Mobile Number : &nbsp;&nbsp;&nbsp;
            {{ userInfo.clientData && userInfo.clientData.phone }}</span
          >
        </div>
      </div>
    </vs-col>
    <vs-col :lg="7" :sm="12">
      <div class="text-primary-light mt-4">&nbsp;</div>
      <div class="dropdown">
        <h1 class="ml-4">Make Payment</h1>
      </div>
      <div class="chart-container">
        <h5 class="selected-text">Payment Through</h5>
        <div class="row justify-content-center">
          <div class="radio_button">
            <vs-radio v-model="picked" val="online">
              Online
            </vs-radio>
            <vs-radio v-model="picked" val="voucher">
              Voucher
            </vs-radio>
          </div>
          <div v-if="picked === 'online'">
            <div class="text_input">
              <vs-input
                v-model="form.price"
                label="Enter Amount"
                placeholder="Enter Amount"
              />
            </div>
            <div class="button_content">
              <vs-button class="button1" @click="">
                Cancel
              </vs-button>
              <paystack
                class="button2"
                :amount="form.price * 100"
                :email="userInfo.clientData.email"
                :paystackkey="paystackKey"
                :reference="reference"
                :callback="processPayment"
                :close="close"
                :embed="false"
                currency="NGN"
              >
                Make Payment
              </paystack>
            </div>
          </div>
          <div v-if="picked === 'voucher'">
            <div class="text_input">
              <vs-input
                v-model.trim="form.voucherCode"
                label="Enter Voucher Code"
                placeholder="Enter  Voucher Code"
              />
            </div>

            <div class="button_content">
              <vs-button class="button1" @click="">
                Cancel
              </vs-button>
              <vs-button class="button2" @click="setRedeem">
                Make Topup
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-col>
  </vs-row>
</template>
<script>
import paystack from "vue-paystack";
import { BASE_URL, PAYSTACK_KEY } from "../../services";
import { getTopup, makeOnlinePayment, redeem } from "../../services/dashboard";
import { extractError } from "../../utils/error";
export default {
  data() {
    return {
      paystackKey: PAYSTACK_KEY,
      subscriberId: JSON.parse(localStorage.getItem("in:profile")).accountNo,
      mobileNo: JSON.parse(localStorage.getItem("in:profile")).phone,
      balance: JSON.parse(localStorage.getItem("in:profile")).balanceAmount,
      picked: "online",

      paymentPayload: {
        money: 0,
        hostedPayment: 1,
        key: "FLWPUBK_TEST-dbacaad48125d6a50b6a15c0df5cba58-X",
        reference: "",
        redirect: ""
      },
      form: {
        title: "",
        email: "",
        number: "",
        address: "",
        city: "",
        state: "",
        balanceamount: "",
        voucherCode: ""
      },

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,

      clientId: null
    };
  },
  components: {
    paystack
  },
  computed: {
    userInfo() {
      return this.$store.getters["auth/getUser"];
    },
    dataTopupList() {
      return this.$store.getters["dashboard/getTopupData"];
    },
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }
  },
  methods: {
    async setRedeem() {
      const loading = this.$vs.loading({
        text: "Please Wait.",
        type: "circles",
        color: "#d5397b"
      });
      try {
        const payload = {
          clientId: this.userInfo.clientId,
          paymentMethod: "voucher",
          pinNumber: this.form.voucherCode
        };
        console.log(payload);
        await this.$store.dispatch("dashboard/setRedeem", payload);
        this.$swal.fire({
          title: "Success!",
          text: "Invoice generated successfully!",
          icon: "success"
        });
      } catch (e) {
        console.log(e);
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: e.message.errors
            ? e.message.errors[0].defaultUserMessage
            : "Something went wrong!"
        });
      }
      loading.close();
    },
    async myFunction() {
      try {
        const response = await getTopup(this.userInfo.clientId);
        this.clientId = response.data.id;
        this.customers = response.data;
        this.show = true;
        this.form = {
          title: this.customers.title,
          price: this.customers.orderData[0].price,
          id: this.customers.orderData[0].id,
          balanceamount: this.customers.balanceAmount,
          email: this.customers.email,
          number: this.customers.phone,
          stbNumber: this.customers.hwSerialNumber,
          planName: this.customers.orderData[0].planDescription,
          expiryDate: this.getDate(this.customers.orderData[0].endDate),
          planAmount: this.customers.planamount
        };
      } catch (err) {
        console.log(err);
        const message = extractError(err);
        this.$showError(message);
      }
    },
    processPayment: val => {
      window.alert("Payment recieved", val);
    },
    close: () => {
      console.log("You closed checkout page");
    }
  },
  mounted() {
    this.myFunction();
  }
};
</script>

<style>
.invoice-card {
  background: linear-gradient(135deg, #6572bb 0%, #2b3674 100%);
  width: 100%;
  padding: 20px;
  color: #ffffff;
  border-radius: 16px;
}
.chart-container {
  background: #fff;
  padding: 20px;
  margin: 0 1rem;
  border-radius: 20px;
}
.topup_img {
  margin-top: 20px;
}
.topup_text {
  text-align: center;
  justify-content: center;
  padding: 10px 10px;
  display: flex;
  cursor: pointer;
}
.text {
  text-align: center;
  justify-content: center;
  padding: 15px 10px;
  display: flex;
  cursor: pointer;
}
.radio_button {
  display: flex;
  margin-top: 20px;
  margin-left: 15px;
}
.text_input {
  margin-top: 30px;
  margin-left: 15px;
}
.button_content {
  display: flex;
  justify-content: space-evenly;
}
.button1 {
  width: 200px;
  background-color: #fff;
  color: red;
  border: 1px solid red;
  font-weight: bold;
  height: 40px;
}
.button2 {
  width: 200px;
  background-color: #30a852;
  font-weight: bold;
  height: 40px;
  color: #fff;
  border: 1px solid #30a852;
  border-radius: 5px;
}
</style>
